import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { groupBy, orderBy, sortBy, get } from "lodash";
import Lightbox from "react-images";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { compose, setDisplayName } from "recompose";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import { Popover, PopoverBody } from "reactstrap";
import LocalShipping from "@material-ui/icons/LocalShipping";
import immutableToJS from "helpers/immutableToJS";
import {
  includesSearchText,
  addTagValue,
  getOrganizationUID,
  scrollTo,
  toStartCaseWithSlash,
  formatPrice,
  decimalFixed,
  toStartCase
} from "helpers/utils";
import {
  AddVendorButton,
  HighlightText,
  injectIntl,
  Pagination,
  PaginationContainer,
  Tags
} from "components";
import { selectState } from "redux/selectors"
import StoreTable from './StoreTable';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";

const styles = () => ({
  activeViewModeButton: {
    color: "#0093ff",
    height: "1.5em",
    width: "1.5em"
  },
  flexWrap: {
    display: "flex",
    flexWrap: "wrap"
  },
  normalViewModeButton: {
    color: "black",
    height: "1.5em",
    width: "1.5em"
  },
  red: { color: "red" },
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start"
  },
  sortBtnLabel: {
    color: "#ff5722",
    fontSize: "0.65rem",
    fontWeight: 600,
    textTransform: "none"
  },
  tab: { backgroundColor: "#ffffff", minWidth: 80 },
  tabIndicator: { backgroundColor: "#5b98ed" },
  tabLabel: {
    fontWeight: 600,
    color: "#5b98ed",
    fontSize: "1.2rem"
  },
  cardMedia: {
    paddingTop: "60%"
  },
  cardContent: {
    flexGrow: 1,
    paddingLeft: "8px",
    paddingRight: "8px",
    paddingBottom: "5px !important"
  },
  cardMobile: {
    height: "100%",
    display: "flex",
    flexDirection: "row"
  },
  cardMediaMobile: {
    width: "80px"
  },
  cardContentMobile: {
    flexGrow: 1,
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingTop: "8px",
    paddingBottom: "10px !important"
  }
});

class CardDetails extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    setHotNotification: PropTypes.func,
    isConsumer: PropTypes.bool
  };

  static propTypes = {
    account: PropTypes.shape({}),
    classes: PropTypes.shape({}).isRequired,
    currentRoleId: PropTypes.number,
    connection: PropTypes.shape({}),
    details: PropTypes.arrayOf(PropTypes.shape({})),
    globals: PropTypes.arrayOf(PropTypes.shape({})),
    iconDirectionForOrder: PropTypes.node.isRequired,
    requesting: PropTypes.bool,
    searchText: PropTypes.string,
    sortDirection: PropTypes.string,
    formatMessage: PropTypes.func.isRequired,
    onSortTimeStamp: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
    accessToken: PropTypes.string,
    sellers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    })).isRequired,
  };

  static defaultProps = {
    account: {},
    details: [],
    globals: [],
    currentRoleId: 3,
    connection: {},
    requesting: false,
    searchText: "",
    sortDirection: "",
    isMobile: false,
    accessToken: null,
  };

  state = {
    currentPageIndex: 1,
    dataFiltered: [],
    tableViewMode: 1,
    currentImage: 0,
    lightboxIsOpen: false,
    distributorsPopup: false,
    distributorsMobilePopup: false,
    open: false,
    dialogMessage: ""
  };

  componentWillMount() {
    this.setState({ dataFiltered: this.getDataWithoutFilter(this.props) });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchText !== nextProps.searchText) {
      this.setState({
        currentPageIndex: 1,
        dataFiltered: this.getDataWithoutFilter(nextProps)
      });
    } else if (
      this.props.details !== nextProps.details ||
      this.props.sortDirection !== nextProps.sortDirection
    ) {
      this.setState({ dataFiltered: this.getDataWithoutFilter(nextProps) });
    }
  }

  onPageClick = currentPageIndex => {
    setTimeout(() => scrollTo("store-detail"), 100);
    this.setState({ currentPageIndex });
  };

  getDataWithoutFilter = ({ details, searchText, sortDirection, tags }) => {
    const data = [];

    if (details) {
      const newInfo = groupBy(
        addTagValue(details, tags),
        item => item.productData.category
      );
      const categories = sortBy(Object.keys(newInfo));

      categories.forEach(category => {
        const groupItemsInfo = newInfo[category];
        const nameField = r => r.productData.name;
        const subNameField = r => r.productData.subname;
        const sortedGroupItems = sortDirection
          ? orderBy(
              groupItemsInfo,
              ["updatedAt", nameField, subNameField, "tagValue"],
              [sortDirection, "asc", "asc", "asc"]
            )
          : orderBy(groupItemsInfo, [nameField, subNameField, "tagValue"]);
        data.push(...sortedGroupItems);
      });
    }

    const filteredData = data.filter(subItem =>
      includesSearchText(searchText, [
        subItem.description,
        toStartCaseWithSlash(subItem.productData.category),
        subItem.productData.name,
        subItem.productData.subname,
        subItem.tags.join(" ")
      ])
    );
    const result = [];
    filteredData.forEach(groupItemInfo => {
      result.push({
        ...groupItemInfo,
        sourcename: groupItemInfo.seller ? groupItemInfo.seller.companyName : ""
      });
    });

    const sortedFilteredData = sortDirection
      ? orderBy(result, ["updatedAt"], [sortDirection])
      : result;

    return sortedFilteredData;
  };

  handleClickOpen = dialogMessage => {
    this.setState({ open: true, dialogMessage });
  };

  handleClose = () => {
    this.setState({ open: false, dialogMessage: "" });
  };

  getFields = (isMobile = false) => {
    const {
      classes,
      formatMessage,
      iconDirectionForOrder,
      searchText,
      onSortTimeStamp,
      currentRoleId
    } = this.props;
    const fields = [];

    const qty = row =>
      (
        <div
          style={{ paddingRight: 5, width: "100%" }}
          className="normal-font red"
        >
          <span className={"normal-font"}>
            {row.availableQuantity === ""
              ? "0"
              : Math.trunc(parseFloat(row.availableQuantity))}
          </span>
        </div>
      ) || "0";

    const bulk = row => (
      <span className="qty-alert">
        {row.isBulk ? (
          <span
            className={`${row.isBulk && row.isMinCount ? "" : "hide"} ${
              row.approved ? "normal-font red" : ""
            }`}
          >
            {row.bulkTotalQty === "" ? "03" : decimalFixed(row.bulkTotalQty)}
          </span>
        ) : (
          ""
        )}
      </span>
    );

    if (isMobile) {
      fields.push({
        label: "",
        render: row => (
          <div className="mobile-group-data-first">
            <div
              className={`mobile-group-data-item mr-2 highlight weight-500`}
              style={{ fontSize: "20px" }}
            >
              <HighlightText
                highlight={searchText}
                text={[row.name, row.subname].join(", ")}
              />
            </div>
            {row.tags ? (
              <div className={classes.flexWrap}>
                <Tags
                  approved={row.approved}
                  defaultTags={row.tags}
                  removable={false}
                  showDropdown={false}
                  size="small"
                />
              </div>
            ) : null}
            <div className="ml-2">
              {row.image ? (
                <img
                  src={row.image}
                  alt={row.image}
                  style={{
                    height: 50,
                    objectFit: "unset",
                    width: 50,
                    cursor: "pointer"
                  }}
                  onClick={() => this.openLightbox(row)}
                />
              ) : null}
            </div>
          </div>
        )
      });
      fields.push(
        {
          label: "",
          render: row => {
            const rowId = `${row.id}_${row.index}`;
            return (
              <div
                className={`mobile-group-data row ml-0 mr-0 mt-2 ${
                  row.isBulk ? "mb-2" : ""
                }`}
              >
                <div
                  style={{ justifyContent: "flex-start", fontSize: "14px" }}
                  className="mobile-group-data-item normal-font col-4 pl-0 pr-0 "
                >
                  {row.count} {row.uom} {row.pack}
                </div>
                <div
                  style={{ justifyContent: "center", fontWeight: "500" }}
                  className="price-group d-flex mobile-group-data-item col-4"
                >
                  {/* Total Price */}
                  <span>
                    <span
                      style={{
                        alignItems: "center",
                        color: "black",
                        display: "flex",
                        justifyContent: "center"
                      }}
                    >
                      $&nbsp;
                      {row.price === "0.00" || !row.price ? "0.00" : row.price}
                    </span>
                  </span>

                  {/* Price */}
                  <span
                    className="grey"
                    style={{ paddingLeft: "8px", color: "#459dfe" }}
                  >
                    <span>
                      $
                      {formatPrice(
                        (row.cost * (100 - (row.discount || 0))) / 100
                      )}
                    </span>
                  </span>
                </div>
                {row.isBulk && <div>{bulk(row)}</div>}
                <div className={`small-font col-3 pr-0`}>
                  <span
                    className="d-flex"
                    style={{ justifyContent: "center", alignItems: "center" }}
                  >
                    <span
                      className="red d-flex"
                      style={{ alignItems: "center" }}
                    >
                      {qty(row)}&nbsp;
                    </span>
                    <span style={{ marginRight: 10 }} className="italic">
                      {formatMessage("left")}
                    </span>
                  </span>
                </div>
              </div>
            );
          },
          title: () => ""
        },
        {
          className: "info",
          colSpan: 2,
          label: formatMessage("info"),
          name: "description",
          render: row => (
            <div style={{ marginTop: "10px", marginBottom: "10px" }}>
              {row.description}
            </div>
          ),
          title: row => row.description
        }
      );
    } else {
      fields.push({
        className: "category",
        colSpan: 2,
        label: formatMessage("Category"),
        name: "category",
        render: data => (
          <div className="category-pane">
            <span className="small-font category-title">
              <HighlightText
                highlight={searchText}
                text={toStartCaseWithSlash(data.category)}
              />
            </span>
          </div>
        ),
        title: row => row.category
      });
      fields.push({
        className: "highlight normal-font large-font-for-mobile",
        colSpan: 2,
        label: formatMessage("IN"),
        name: "name",
        render: data => (
          <span className="item-name-pane">
            <div title={data.name}>
              <HighlightText
                className="white-space"
                highlight={searchText}
                text={data.name}
              />
            </div>
          </span>
        ),
        title: row => row.name
      });
      fields.push({
        className: "highlight normal-font big-font-for-mobile",
        colSpan: 2,
        label: formatMessage("ISN"),
        name: "subname",
        render: data => (
          <span className="item-sub-name">
            <HighlightText highlight={searchText} text={data.subname} />
          </span>
        ),
        title: row => row.subname
      });
      fields.push({
        className: "info",
        colSpan: 2,
        label: formatMessage("Info"),
        name: "description",
        render: row => (
          <span style={{ lineHeight: "15px" }}>
            {row.description
              ? `${row.description.substr(0, 57)}${
                  row.description.length > 57 ? "..." : ""
                }`
              : ""}
          </span>
        ),
        title: row => row.description
      });
      fields.push({
        colSpan: 3,
        label: formatMessage("Tags"),
        name: "tags",
        render: data =>
          data.tags ? (
            <div className={classes.flexWrap}>
              <Tags
                approved
                defaultTags={data.tags}
                removable={false}
                showDropdown={false}
                size="small"
                highlightText={searchText}
              />
            </div>
          ) : null
      });

      //show vendor name if is distributor
      if (currentRoleId === 3) {
        fields.push({
          className: "tiny-font",
          colSpan: 3,
          label: formatMessage("Vendor"),
          mobileHidden: true,
          name: "sourcename",
          render: data => (
            <HighlightText highlight={searchText} text={data.sourcename} />
          ),
          title: () => ""
        });
      }
      fields.push({
        className: "highlight normal-font",
        colSpan: 2,
        label: formatMessage("Pack-Out"),
        name: "uom",
        render: data => <span>{`${data.count} ${data.uom} ${data.pack}`}</span>,
        title: data => `${data.count} ${data.uom} ${data.pack}`
      });

      fields.push({
        className: row => (row.isBulk && row.isMinCount ? null : "hide"),
        colSpan: 2,
        label: formatMessage("Bulk Base"),
        name: "availableQuantity",
        render: row => bulk(row),
        title: formatMessage("Qty")
      });
      fields.push({
        colSpan: 2,
        label: formatMessage("Qty"),
        name: "totalQtyByPack",
        render: row => qty(row),
        title: formatMessage("Qty By Pack")
      });
    }

    fields.push({ label: "", name: "action", colSpan: 1 });

    return fields;
  };

  toggleForTableViewMode = (event, toggled) => {
    this.setState({ tableViewMode: toggled });
  };

  openLightbox = item => {
    const imageIndex = this.lightboxImages.findIndex(i => i.itemId === item.id);
    this.setState({
      currentImage: imageIndex >= 0 ? imageIndex : 0,
      lightboxIsOpen: true
    });
  };

  closeLightbox = () =>
    this.setState({ currentImage: 0, lightboxIsOpen: false });

  gotoPreviousImage = () =>
    this.setState({ currentImage: this.state.currentImage - 1 });

  gotoNextImage = () =>
    this.setState({ currentImage: this.state.currentImage + 1 });

  gotoImage = index => this.setState({ currentImage: index });

  handleClickLightboxImage = () => {
    if (this.state.currentImage === this.lightboxImages.length - 1) return;
    this.gotoNextImage();
  };

  renderMobileFarmConnections = connection => {
    const { formatMessage } = this.props;
    const { distributorsMobilePopup } = this.state;
    const { restaurantsCount, distributors } = connection;

    return (
      <div className="d-flex" style={{ width: "100%" }}>
        <div
          className="d-flex"
          style={{
            alignItems: "center",
            width: "100%",
            justifyContent: "center"
          }}
        >
          <span>
            <a
              href="#"
              onClick={e => {
                e.preventDefault();
                this.setState({ distributorsMobilePopup: true });
              }}
              id="distributors2"
            >
              <LocalShipping style={{ fontSize: 30, marginRight: "10px" }} />
              {`${formatMessage("View Distributors")}: `}
              {distributors.length}
            </a>
          </span>
        </div>
        <div
          className="d-flex"
          style={{
            alignItems: "center",
            width: "100%",
            justifyContent: "center"
          }}
        >
          <div>
            {`${formatMessage("Customers")}: ${restaurantsCount +
              distributors.length}`}
          </div>
        </div>
        <Popover
          className=""
          placement="bottom"
          isOpen={distributorsMobilePopup}
          toggle={() => this.setState({ distributorsMobilePopup: false })}
          target="distributors2"
        >
          <PopoverBody>
            {distributors.map(d => (
              <div key={d.id}>
                <Link
                  to={`+${getOrganizationUID(d.buyer.profile.companyName)}`}
                  onClick={() =>
                    this.setState({ distributorsMobilePopup: false })
                  }
                >
                  {d.buyer.profile.companyName}
                </Link>
              </div>
            ))}
          </PopoverBody>
        </Popover>
      </div>
    );
  };

  renderMobileDistributorConnections = connection => {
    const { formatMessage } = this.props;
    const { buyersCount, sellersCount } = connection;

    return (
      <div
        className="d-flex"
        style={{
          alignItems: "center",
          width: "100%",
          justifyContent: "center"
        }}
      >
        <span style={{ marginRight: 20 }}>
          {`${formatMessage("Farms")}: ${sellersCount}`}
        </span>
        <span>{`${formatMessage("Customers")}: ${buyersCount}`}</span>
      </div>
    );
  };

  getDataGrouped = data => {
    const { contact } = this.props;
    const isAllowedZero = this.checkIsAllowedZero(contact);
    const modifiedData = [];
    if (!data) return [];
    if (data) {
      let packRowCount = 0;
      data.packrows.forEach(packrow => {
        if (parseFloat(packrow.availableQuantity, 10) === 0 && !isAllowedZero)
          return;
        packRowCount++;
        if (packRowCount > 1) {
          modifiedData.push({
            category: toStartCase(data.productData.category),
            ...data,
            ...packrow,
            hide: [
              "action",
              "category",
              "description",
              "image",
              "name",
              "sourcename",
              "status",
              "subname",
              "tags",
              "updatedAt"
            ],
            id: data.id,
            name: data.productData.name,
            subname: data.productData.subname
          });
          return;
        }
        modifiedData.push({
          category: toStartCase(data.productData.category),
          ...data,
          ...packrow,
          id: data.id,
          name: data.productData.name,
          subname: data.productData.subname
        });
      });
    }

    return modifiedData;
  };

  checkIsAllowedZero = contact => {
    const { isPublic } = this.context;
    const sellerRoleId = get(contact, "sellerProfile.roleId");
    const sellerRole =
      {
        2: "Buyer",
        3: "Distributor",
        4: "Seller",
        5: "Consumer"
      }[sellerRoleId] || "Personal";

    const buyerRoleId = get(contact, "buyerProfile.roleId");
    const buyerRole =
      {
        2: "Buyer",
        3: "Distributor",
        4: "Seller",
        5: "Consumer"
      }[buyerRoleId] || "Personal";

    return isPublic
      ? true
      : sellerRole === "Seller" &&
          (buyerRole === "Buyer" ||
            buyerRole === "Consumer" ||
            buyerRole === "Personal");
  };

  render() {
    const {
      formatMessage,
      requesting,
      classes,
      globals,
      connection,
      currentRoleId,
      account,
      isMobile,
      accessToken,
      sellers
    } = this.props;

    const {
      currentPageIndex,
      dataFiltered,
      tableViewMode,
      currentImage,
      lightboxIsOpen,
      open,
      dialogMessage
    } = this.state;
    const {
      currentUser,
     
    } = this.context;
    const perPage =
      (globals.find(({ name }) => name === "itemsPerPage") || {}).value || 100;
    const paginatedData = dataFiltered.slice(
      (currentPageIndex - 1) * perPage,
      currentPageIndex * perPage
    );

    this.lightboxImages = paginatedData
      .filter(g => !!g.image)
      .map(({ id, image, productData }) => ({
        itemId: id,
        src: image,
        caption: `${productData.category} - ${productData.name}, ${productData.subname}`
      }));
    const fields = this.getFields();
    const fieldsForMobile = this.getFields(true);
    const pageCount = Math.ceil(dataFiltered.length / perPage);
    let actualCategory = "";
    const sellerIds = sellers.map(({ sellerId }) => sellerId);

    return (
      <div
        name="store-detail"
        className={`store-detail loading-enabled ${
          requesting && dataFiltered.length ? "loading" : ""
        }`}
      >
        {pageCount > 1 && (
          <PaginationContainer>
            <Pagination
              active={currentPageIndex}
              batchCount={3}
              count={pageCount}
              light
              onPageClick={this.onPageClick}
            />
          </PaginationContainer>
        )}
        <div className="mobile-tool-bar">
          <div
            className="d-lg-up-none"
            style={{ paddingTop: "5px", paddingBottom: "10px" }}
          >
            <div className="row">
              <div
                className="col"
                style={{ textAlign: "center", marginTop: "15px" }}
              >
                <AddVendorButton vendorAccount={account} />
              </div>
            </div>
            <div className="row" style={{ padding: "10px" }}>
              {currentRoleId === 4 &&
                !requesting &&
                this.renderMobileFarmConnections(connection)}
              {currentRoleId === 3 &&
                !requesting &&
                this.renderMobileDistributorConnections(connection)}
            </div>
          </div>
        </div>
        {requesting && !dataFiltered.length && (
          <div className="store-progress">
            <CircularProgress />
          </div>
        )}
        {account.currentRoleId === 3 ? (
          paginatedData.length ? (
            <div>
              <div className="smart-table">
                {
                  <StoreTable fields={fields} threshold="md">
                    {paginatedData.map((tempDataItem, index) => (
                      <StoreTable.StoreTableRow
                        data={tempDataItem}
                        fields={fields}
                        formatMessage={formatMessage}
                        key={index}
                        onImageClick={() => this.openLightbox(tempDataItem)}
                      />
                    ))}
                  </StoreTable>
                }
                {
                  <StoreTable.StoreMobileTable threshold="md">
                    {paginatedData.map((tempDataItem, index) => (
                      <StoreTable.StoreMobileTableRow
                        data={tempDataItem}
                        fields={fieldsForMobile}
                        formatMessage={formatMessage}
                        key={index}
                        threshold="s"
                        onImageClick={() => this.openLightbox(tempDataItem)}
                      />
                    ))}
                  </StoreTable.StoreMobileTable>
                }
              </div>
            </div>
          ) : (
            ""
          )
        ) : (
          <div className={`grid-view ${classes.root}`}>
            <Grid
              container
              spacing={24}
              style={!isMobile ? { maxWidth: "1200px", margin: "auto" } : {}}
            >
              {sortBy(paginatedData, [
                "category",
                "productData.name",
                "packrows[0].count"
              ])
                .filter(item => !item.hide)
                .map((item, index) => {
                  const data = this.getDataGrouped(item);

                  return data.map((row, index) => {
                    const imageUrl = row.image || "/assets/images/image-not-available-1.png";
                    const val = formatPrice((row.price * (100 - (row.discount || 0))) / 100).toString();
                    const dec_pos = val.indexOf(".");
                    const showCategoryTitle = actualCategory === row.category ? false : true;
                    actualCategory = row.category;

                    return isMobile ? (
                      <Grid
                        item
                        key={index}
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ padding: 0 }}
                      >
                        {showCategoryTitle && (
                          <div
                            style={{
                              fontSize: 22,
                              fontWeight: 300,
                              color: "grey",
                              paddingBottom: 15,
                              paddingTop: 15,
                              paddingLeft: 15,
                              textAlign: "left"
                            }}
                          >
                            {row.category}
                          </div>
                        )}
                        <Card className={classes.cardMobile}>
                          <div>
                            <img
                              src={imageUrl}
                              alt=""
                              width="170"
                              height="130"
                              style={{ objectFit: "cover" }}
                            ></img>
                          </div>
                          <CardContent className={classes.cardContentMobile}>
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="h2"
                              style={{ fontSize: "17px", fontWeight: 500 }}
                            >
                              {row.name},
                              <span>
                                &nbsp;{row.subname.substring(0, 13)}{" "}
                                {row.subname.length > 13 ? "..." : ""}{" "}
                              </span>
                              <span style={{ fontWeight: 300 }}>
                                {row.tags.join(", ")}{" "}
                              </span>
                            </Typography>
                            <div
                              style={{
                                marginTop: "8px",
                                fontSize: "12px",
                                color: "#151b1e80"
                              }}
                            >
                              <Link
                                to={`/shop@${getOrganizationUID(
                                  row.sourcename
                                )}`}
                              >
                                {row.sourcename}
                              </Link>
                            </div>
                          </CardContent>
                        </Card>
                      </Grid>
                    ) : (
                      <Grid item key={index} style={{ width: "240px" }}>
                        <Card className={classes.card}>
                          <CardMedia
                            className={classes.cardMedia}
                            image={imageUrl}
                            title=""
                          />
                          <CardContent className={classes.cardContent}>
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="h2"
                              style={{ fontSize: "17px", fontWeight: 500 }}
                            >
                              {row.name},<span>&nbsp;{row.subname} </span>
                              <span
                                style={{ fontWeight: 300, fontSize: "13px" }}
                              >
                                {row.tags.join(", ")}{" "}
                              </span>
                            </Typography>
                            <div
                              style={{
                                marginTop: "8px",
                                fontSize: "12px",
                                color: "#151b1e80"
                              }}
                            >
                              <Link
                                to={`/shop@${getOrganizationUID(
                                  row.sourcename
                                )}`}
                              >
                                {row.sourcename}
                              </Link>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: "10px",
                                marginBottom: "10px"
                              }}
                            >
                              <div
                                key={index}
                                className="uom"
                                style={{ fontSize: "13px", fontWeight: "bold" }}
                              >
                                <span>{`${row.count} ${row.uom} ${row.pack}`}</span>
                              </div>
                              { accessToken &&  sellerIds.indexOf(account.id) != -1 && (
                                <div
                                  style={{ fontSize: "16px", fontWeight: "bold" }}
                                >
                                  <span>
                                    {`${val.substring(0, dec_pos)}`}
                                    <sup style={{ fontWeight: 300 }}>
                                      {" "}
                                      {`${val.substring(dec_pos + 1)}`}
                                    </sup>
                                  </span>
                                </div>
                              )}
                            </div>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  });
                })}
            </Grid>
          </div>
        )}
        <Lightbox
          currentImage={currentImage}
          images={this.lightboxImages}
          isOpen={lightboxIsOpen}
          onClickImage={this.handleClickLightboxImage}
          onClickNext={this.gotoNextImage}
          onClickPrev={this.gotoPreviousImage}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
          showThumbnails
        />
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Description</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState("options", "globals")(state, "globals"),
  ...selectState("options", "tags")(state, "tags")
});

export default compose(
  setDisplayName("CardDetails"),
  connect(mapStateToProps),
  withStyles(styles),
  injectIntl,
  immutableToJS
)(CardDetails);
